module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAUCAYAAABbLMdoAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADHSURBVHgBrZLhDcIgEIXhWKAjdISOYCcwbFAnsY7gBMYJaO0AHUFHcAT/GzjvCCb9wdGa+BIIhO+9BwlK/SDtnKu1MRf0/mCtfZZgiDNircHMbCwm8xTTAWbeYvCt1BCT+RBDaKlCUcOdzI2Y/NWioUoNDxFeM+hcnWTIwpJBhJOhSoZGG+igBFPai+CB1+Ht22LyOE1HDNjTuFq77/RWUEkPzIEsKIDnJZhNHMYbOjf2au0xfwX58+/4L9MdT3THIhzFBrVBH59ylm230j5VAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/to.png
// module id = qknq
// module chunks = 36